import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/shared/components/ui/dialog';
import { HistoricalRequestForm } from './HistoricalRequestForm';

interface RegisterAbsenceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** "Registrar ausencia" modal on the "Saldos" panel — Owner/Admin only. */
export function RegisterAbsenceDialog({ open, onOpenChange }: RegisterAbsenceDialogProps) {
  const { t } = useTranslation('timeOff');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="flex max-h-[85vh] flex-col gap-0 p-0"
        data-testid="time-off-register-absence-dialog"
      >
        <DialogHeader className="shrink-0 border-b p-6">
          <DialogTitle>{t('team.balances.registerDialog.title')}</DialogTitle>
          <DialogDescription>{t('team.balances.registerDialog.description')}</DialogDescription>
        </DialogHeader>
        <HistoricalRequestForm
          onSuccess={() => onOpenChange(false)}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
